{
  "guideContent": {
    "insert": "Inserir conteúdo",
    "insertHeader": "Cabeçalho",
    "insertText": "Texto",
    "insertStep": "Passo",
    "headerPlaceholder": "Título da seção",
    "textPlaceholder": "Escreva um texto...",
    "moveUp": "Mover para cima",
    "moveDown": "Mover para baixo",
    "delete": "Excluir"
  },
  "common": {
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "previous": "Anterior",
    "next": "Próximo"
  },
  "auth": {
    "login": {
      "title": "Entrar",
      "email": "Email",
      "password": "Senha",
      "submit": "Entrar",
      "submitting": "Entrando...",
      "noAccount": "Ainda não tem conta?",
      "signupLink": "Criar conta",
      "error": "Email ou senha incorretos.",
      "googleButton": "Entrar com Google",
      "divider": "ou"
    },
    "extension_callback": {
      "title": "Login concluído!",
      "description": "Você pode fechar esta aba e voltar para a extensão."
    },
    "signup": {
      "title": "Criar conta",
      "name": "Nome",
      "email": "Email",
      "password": "Senha",
      "passwordConfirmation": "Confirmar senha",
      "submit": "Criar conta",
      "submitting": "Criando...",
      "hasAccount": "Já tem uma conta?",
      "loginLink": "Entrar",
      "googleButton": "Criar conta com Google",
      "divider": "ou"
    }
  },
  "home": {
    "welcome": "Bem-vindo ao Instruo",
    "subtitle": "Sua área de trabalho está pronta."
  },
  "nav": {
    "guides": "Guias",
    "company": "Empresa",
    "billing": "Cobrança",
    "aiWriters": "AI Writers",
    "settings": "Configurações",
    "logout": "Sair",
    "installExtension": "Instalar Extensão"
  },
  "guides": {
    "index": {
      "title": "Meus Guias",
      "newGuide": "Novo Guia",
      "empty": "Você ainda não criou nenhum guia.",
      "emptyAction": "Crie seu primeiro guia",
      "gettingStarted": {
        "title": "Crie seu primeiro guia em 3 passos",
        "subtitle": "O Instruo transforma suas gravações de tela em documentação passo a passo.",
        "step1Title": "Instale a extensão do navegador",
        "step1Description": "Adicione o Instruo Recorder ao seu navegador. Ele captura screenshots e cliques enquanto você trabalha.",
        "step1DescriptionUnsupported": "O Instruo Recorder está disponível para Chrome e Edge. Abra esta página em um navegador compatível para instalá-lo.",
        "step1Unsupported": "Requer Chrome ou Edge",
        "step1Cta": "Instalar extensão",
        "step1ImageAlt": "Página da extensão Instruo Recorder na Chrome Web Store com o botão de instalação",
        "step2Title": "Grave seu fluxo de trabalho",
        "step2Description": "Clique em gravar, execute sua tarefa e narre se quiser. A extensão captura tudo automaticamente.",
        "step2ImageAlt": "Extensão Instruo Recorder gravando um fluxo de trabalho e capturando cada ação automaticamente",
        "step3Title": "A IA refina seu guia",
        "step3Description": "O AI Writer do Instruo transforma sua gravação em um guia claro e profissional — pronto para compartilhar.",
        "step3ImageAlt": "Guia finalizado no Instruo com passos e descrições geradas pela IA",
        "manualCreate": "ou crie um guia manualmente"
      },
      "upgradeDescription": "Você atingiu o limite de guias do plano Grátis. Faça upgrade para criar guias ilimitados.",
      "allGuides": "Todos",
      "myGuides": "Pessoal",
      "companyGuides": "Empresa",
      "searchPlaceholder": "Buscar guias...",
      "sortPosition": "Ordem personalizada",
      "sortTitleAsc": "Título A-Z",
      "sortTitleDesc": "Título Z-A",
      "sortNewest": "Mais recentes",
      "sortOldest": "Mais antigos",
      "noResults": "Nenhum guia encontrado.",
      "updatedAgo": "Atualizado {time}",
      "creating": "Criando..."
    },
    "defaultTitle": "Guia sem título",
    "show": {
      "edit": "Editar",
      "delete": "Excluir",
      "deleteConfirm": "Este guia e todos os seus passos serão excluídos permanentemente.",
      "deleteTitle": "Excluir guia?",
      "backToGuides": "Voltar aos guias",
      "publicLink": "Link público",
      "copyLink": "Copiar link",
      "linkCopied": "Copiado!",
      "viewGuide": "Ver guia",
      "exportPdf": "Exportar PDF",
      "editTitle": "Clique para editar o título"
    },
    "edit": {
      "title": "Editar Guia",
      "companyLabel": "Empresa",
      "companyNone": "Nenhum (pessoal)",
      "visibilityLabel": "Visibilidade",
      "visibilityPrivate": "Privado",
      "visibilityCompany": "Empresa",
      "visibilityPublic": "Público",
      "visibilityHeading": "Quem pode ver este guia?",
      "visibilityPrivateHelp": "Apenas você pode ver este guia.",
      "visibilityPublicHelp": "Qualquer pessoa com o link pode ver.",
      "visibilityPortalHeading": "Portal da empresa",
      "visibilityPortalPagePublic": "Público",
      "visibilityPortalPagePrivate": "Apenas membros",
      "visibilityPortalEmpty": "Crie páginas do portal nas configurações da empresa.",
      "visibilityPortalUpsell": "Disponível no plano Business.",
      "submit": "Salvar",
      "submitting": "Salvando...",
      "cancel": "Cancelar",
      "saving": "Salvando...",
      "saved": "Salvo",
      "backToGuide": "Ver guia",
      "viewVideo": "Ver vídeo"
    },
    "visibility": {
      "private": "Privado",
      "company": "Empresa",
      "public": "Público"
    },
    "card": {
      "shareLink": "Compartilhar link"
    }
  },
  "steps": {
    "sectionTitle": "Passos",
    "defaultTitle": "Passo sem título",
    "noteLabel": "Nota",
    "notePlaceholder": "Clique para adicionar uma nota",
    "saved": "Salvo",
    "clickToEdit": "Clique para editar",
    "empty": "Nenhum passo ainda. Adicione o primeiro passo para começar.",
    "addStep": "Adicionar Passo",
    "deleteTitle": "Excluir passo?",
    "deleteConfirm": "Este passo será excluído permanentemente.",
    "screenshot": {
      "label": "Screenshot",
      "upload": "Clique, arraste ou cole (Ctrl+V)",
      "hint": "PNG, JPEG, WebP ou GIF (max 10 MB)",
      "remove": "Remover screenshot",
      "edit": "Pixelizar áreas sensíveis",
      "editHint": "Arraste para criar uma região",
      "editLoadFailed": "Não foi possível carregar a captura para edição.",
      "editSaveFailed": "Falha ao salvar. Tente novamente.",
      "restoreOriginal": "Restaurar original",
      "restoreOriginalTitle": "Restaurar a captura original?",
      "restoreOriginalConfirm": "A versão pixelizada será substituída pela original sem alterações.",
      "restoreOriginalPublicWarning": "Este guia é público. A captura original ficará visível para todos com o link."
    },
    "click": {
      "manage": "Gerenciar clique",
      "placeHint": "Clique para posicionar indicador",
      "editHint": "Clique para mover, clique no indicador para remover"
    },
    "reorder": {
      "dragHandle": "Arraste para reordenar"
    },
    "actions": {
      "menu": "Ações do passo",
      "moveUp": "Mover para cima",
      "moveDown": "Mover para baixo",
      "duplicate": "Duplicar",
      "mergeDown": "Mesclar abaixo",
      "undoMerge": "Desfazer mesclagem",
      "delete": "Excluir"
    }
  },
  "profile": {
    "title": "Configurações",
    "nameLabel": "Nome",
    "emailLabel": "Email",
    "currentPasswordLabel": "Senha atual",
    "newPasswordLabel": "Nova senha",
    "confirmPasswordLabel": "Confirmar nova senha",
    "languageLabel": "Idioma",
    "submit": "Salvar alterações",
    "submitting": "Salvando...",
    "changePassword": "Alterar senha",
    "passwordHint": "Deixe em branco para manter sua senha atual.",
    "apiToken": {
      "title": "Token de API",
      "description": "Use este token para autenticar a extensão do Chrome.",
      "generate": "Gerar token",
      "revoke": "Revogar token",
      "revokeConfirm": "Revogar este token? A extensão do Chrome parará de funcionar até que você gere um novo.",
      "revokeTitle": "Revogar token de API?",
      "active": "Você tem um token de API ativo.",
      "newToken": "Copie seu token agora — ele não será exibido novamente:",
      "copied": "Copiado!"
    },
    "googleLinked": "Conectado com Google",
    "avatar": {
      "title": "Avatar",
      "upload": "Enviar foto",
      "change": "Alterar foto",
      "remove": "Remover",
      "tooLarge": "Arquivo muito grande. Máximo 5MB.",
      "invalidType": "Tipo de arquivo inválido. Use PNG, JPEG, WebP ou GIF."
    }
  },
  "editor": {
    "bold": "Negrito",
    "italic": "Itálico",
    "strike": "Tachado",
    "heading": "Título",
    "bulletList": "Lista com marcadores",
    "orderedList": "Lista numerada",
    "blockquote": "Citação",
    "code": "Código",
    "link": "Link",
    "undo": "Desfazer",
    "redo": "Refazer",
    "linkPrompt": "Digite a URL"
  },
  "aiPolish": {
    "polishAll": "Polir o Guia",
    "polishedState": "Polido",
    "polishSettingsAriaLabel": "Opções de polimento",
    "polishSettingsTooltip": "Escolher AI Writer e influência da narração",
    "polishAllTooltip": "Use IA para reescrever títulos e descrições dos passos no estilo do AI Writer selecionado.",
    "polishAllInProgressTooltip": "A IA está polindo este guia...",
    "polishAllNoChangesTooltip": "O guia já está polido — clique para polir novamente (ex.: outro AI Writer ou influência da narração).",
    "polishingAll": "Polindo o guia...",
    "polishAllPreviewTitle": "Polimento IA — Revisar Alterações",
    "guideTitle": "Título do Guia",
    "acceptSelected": "Aceitar Selecionados",
    "discard": "Descartar",
    "original": "Original",
    "polished": "Polido",
    "originalTitle": "Título Original",
    "polishedTitle": "Título Polido",
    "originalDescription": "Descrição Original",
    "polishedDescription": "Descrição Polida"
  },
  "narration": {
    "processing": "Processando narração...",
    "failed": "Falha no processamento da narração",
    "retry": "Tentar novamente"
  },
  "image": {
    "loading": "Carregando imagem...",
    "loadFailed": "Imagem indisponivel"
  },
  "plan": {
    "free": "Grátis",
    "pro": "Pro",
    "business": "Business",
    "badge": "Plano {plan}",
    "upgradeTitle": "Faça upgrade do seu plano",
    "upgradeDescription": "Desbloqueie mais recursos e limites maiores com um plano pago.",
    "upgradeButton": "Fazer upgrade"
  },
  "pricing": {
    "title": "Escolha seu plano",
    "subtitle": "Escolha o plano ideal para sua equipe.",
    "monthly": "Mensal",
    "annual": "Anual",
    "annualDiscount": "Economize 20%",
    "month": "mês",
    "year": "ano",
    "custom": "Sob consulta",
    "billedAnnually": "{total}/ano cobrado anualmente",
    "popular": "Mais popular",
    "allPlansInclude": "Todos os planos incluem",
    "currentPlan": "Plano atual",
    "subscribe": "Assinar",
    "upgrade": "Fazer upgrade",
    "downgrade": "Fazer downgrade",
    "freeTier": "Grátis para sempre",
    "error": "Algo deu errado. Tente novamente.",
    "features": {
      "seatsIncluded": "{count} membros incluídos",
      "proGuides": "Guias ilimitados",
      "unlimitedSteps": "Passos ilimitados por guia",
      "pdfExport": "Exportação em PDF",
      "analytics": "Analytics de guias",
      "videoExport": "Exportação em vídeo",
      "everythingInPro": "Tudo do plano Pro",
      "companyPortal": "Portal da empresa",
      "customAiWriters": "AI Writers personalizados"
    }
  },
  "checkout": {
    "title": "Concluir pagamento",
    "submit": "Assinar agora",
    "processing": "Processando...",
    "confirmed": "Pagamento confirmado!",
    "redirecting": "Atualizando seu plano...",
    "havePromoCode": "Tem um código promocional?",
    "promoCodeLabel": "Código promocional",
    "promoCodePlaceholder": "Digite o código",
    "promoApply": "Aplicar",
    "promoInvalid": "Código promocional inválido ou expirado.",
    "promoOff": "de desconto",
    "promoMonths": "meses",
    "promoForever": "para sempre",
    "promoApplied": "Desconto aplicado",
    "promoRemove": "Remover",
    "summaryCycleMonthly": "Mensal",
    "summaryCycleAnnual": "Anual",
    "summaryTotal": "Total a cobrar",
    "summarySeats": "{count} assentos",
    "summaryDiscountApplied": "Cupom aplicado"
  },
  "billing": {
    "title": "Cobrança",
    "currentPlan": "Plano atual",
    "status": "Status",
    "statusActive": "Ativo",
    "statusPastDue": "Pagamento pendente",
    "statusCanceled": "Cancelado",
    "statusIncomplete": "Processando",
    "statusTrialing": "Avaliação gratuita",
    "nextInvoice": "Próxima fatura em",
    "changePlan": "Trocar plano",
    "changePlanConfirmTitle": "Trocar plano?",
    "changePlanConfirmMessage": "Seu plano será alterado para {plan}. A diferença será calculada proporcionalmente.",
    "changePlanConfirm": "Confirmar troca",
    "cancelPlan": "Cancelar plano",
    "reactivate": "Reativar",
    "updatePayment": "Atualizar forma de pagamento",
    "cancelConfirmTitle": "Cancelar assinatura?",
    "cancelConfirmMessage": "Você manterá o acesso até o final do período de cobrança, depois seu plano voltará para Grátis.",
    "canceling": "Cancelando...",
    "reactivating": "Reativando...",
    "cancelAtPeriodEnd": "Sua assinatura do plano {plan} será válida até {date}.",
    "pastDueBanner": "Pagamento falhou — atualize sua forma de pagamento.",
    "trialBanner": "Restam {days} dias na sua avaliação gratuita — assine agora para manter seus guias.",
    "subscribeCta": "Assinar agora",
    "trialStatus": "Sua avaliação gratuita",
    "trialDaysLeft": "{days} dias restantes",
    "manageSeats": "Gerenciar membros",
    "manageSeatModal": "Gerenciar Membros",
    "seatsLabel": "Membros",
    "seatsIncludedInPlan": "membros incluídos no plano",
    "seatsUsedByTeam": "membros ativos na empresa",
    "addSeatsButton": "Adicionar {count} Membro(s) ({price})",
    "removeSeatsButton": "Remover {count} Membro(s)",
    "seatUsageIndicator": "Você está usando {used} de {total} assentos",
    "buyMoreSeats": "Comprar mais assentos",
    "seatsDone": "Concluído",
    "processing": "Processando...",
    "nextCharge": "Próxima cobrança",
    "statusCanceling": "Cancelando",
    "invoiceHistory": "Histórico de faturas",
    "invoiceDate": "Data",
    "invoiceAmount": "Valor",
    "invoiceStatus": "Status",
    "viewInvoice": "Ver",
    "noInvoices": "Nenhuma fatura ainda.",
    "invoicePaid": "Pago",
    "giftedBanner": "Seu acesso Business gratuito expira em {date}.",
    "giftedBannerCta": "Assine para manter seus recursos Business após esta data.",
    "giftedTag": "Gratuito",
    "giftedSubscribe": "Assinar agora"
  },
  "redeem": {
    "title": "Resgatar Código",
    "subtitle": "Ative seu plano Business gratuito",
    "planLabel": "Plano",
    "durationLabel": "Duração",
    "durationDays": "{days} dias",
    "activateButton": "Ativar Plano Business",
    "activating": "Ativando...",
    "invalidCode": "Este código é inválido ou não existe.",
    "alreadyRedeemed": "Este código já foi resgatado.",
    "inactive": "Este código não está mais ativo.",
    "alreadySubscribed": "Você já possui uma assinatura ativa.",
    "noCode": "Nenhum código de resgate fornecido."
  },
  "confirmation": {
    "banner": "Confirme seu email para acessar todas as funcionalidades. Verifique sua caixa de entrada.",
    "resendLink": "Reenviar email"
  },
  "companies": {
    "show": {
      "title": "Configurações da Empresa",
      "tabGeneral": "Geral",
      "tabMembers": "Membros",
      "tabPortal": "Portal",
      "nameLabel": "Nome da empresa",
      "save": "Salvar",
      "saving": "Salvando...",
      "deleteCompany": "Excluir empresa",
      "deleteTitle": "Excluir empresa?",
      "deleteConfirm": "Todos os guias voltarão a ser privados. Isso não pode ser desfeito.",
      "members": "Membros",
      "owner": "Proprietário",
      "member": "Membro",
      "removeMember": "Remover",
      "removeTitle": "Remover membro?",
      "removeConfirm": "Este membro perderá acesso aos guias da empresa.",
      "leaveCompany": "Sair da empresa",
      "leaveTitle": "Sair da empresa?",
      "leaveConfirm": "Você perderá acesso aos guias desta empresa.",
      "invitations": "Convidar Membros",
      "saved": "Salvo",
      "inviteLabel": "Endereço de email",
      "invitePlaceholder": "colega@empresa.com",
      "invite": "Enviar convite",
      "inviting": "Enviando...",
      "revokeInvite": "Revogar",
      "revokeTitle": "Revogar convite?",
      "revokeConfirm": "Este link de convite não funcionará mais.",
      "resendInvite": "Reenviar",
      "expiresAt": "Expira em {date}",
      "noInvitations": "Convites enviados aparecem aqui até serem aceitos.",
      "invitationStatus": {
        "pending": "Pendente",
        "accepted": "Aceito",
        "expired": "Expirado"
      }
    },
    "locked": {
      "title": "Portal da Empresa",
      "description": "Faça upgrade para o plano Business para desbloquear o portal da sua empresa e convidar membros.",
      "upgrade": "Upgrade para Business"
    }
  },
  "invitations": {
    "accept": {
      "title": "Entrar na Empresa",
      "message": "Você foi convidado para participar de {companyName}.",
      "submit": "Entrar na Empresa",
      "submitting": "Entrando...",
      "cancel": "Recusar"
    },
    "register": {
      "title": "Crie sua conta",
      "subtitle": "Configure sua conta para entrar em {companyName}.",
      "submit": "Criar conta e entrar na empresa",
      "submitting": "Criando..."
    }
  },
  "trialExpired": {
    "title": "Sua avaliação gratuita terminou",
    "description": "Assine um plano para continuar usando o Instruo e acessar seus guias.",
    "subscriptionExpiredTitle": "Sua assinatura expirou",
    "subscriptionExpiredDescription": "Renove sua assinatura para continuar usando o Instruo.",
    "dataPreserved": "Seus dados estão seguros e estarão disponíveis quando você assinar.",
    "subscribeCta": "Assinar agora"
  },
  "errors": {
    "notFound": {
      "title": "Página não encontrada",
      "description": "A página que você procura não existe ou foi movida.",
      "backHome": "Ir para a página inicial"
    },
    "fallback": {
      "title": "Algo deu errado",
      "description": "Encontramos um erro inesperado. Já fomos notificados e estamos trabalhando para corrigir.",
      "reload": "Recarregar página"
    }
  },
  "publicGuide": {
    "by": "por",
    "step": "Passo",
    "steps": "{count} passos",
    "stepsSingular": "1 passo",
    "poweredBy": "Criado com",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Diminuir zoom",
    "expandImage": "Ver imagem completa",
    "watchVideo": "Assistir video"
  },
  "portal": {
    "title": "Guias",
    "guidesTitle": "Guias",
    "guidesDescription": "Navegue pelos guias de {company}",
    "noGuides": "Nenhum guia publicado ainda",
    "stepSingular": "1 passo",
    "steps": "{count} passos",
    "backToGuides": "Voltar aos guias",
    "poweredBy": "Desenvolvido com",
    "portalSlugLabel": "URL do portal",
    "portalSlugPlaceholder": "sua-empresa",
    "portalSlugHelp": "Seu portal estará em:",
    "portalSlugSave": "Salvar",
    "portalSection": "Portal da Empresa",
    "portalSectionDescription": "Dê à sua empresa uma URL pública onde qualquer pessoa pode navegar pelos seus guias publicados.",
    "portalUpgradeRequired": "Faça upgrade para o plano Business para ativar o portal da empresa.",
    "portalActive": "Seu portal está ativo em:",
    "portalDisabled": "Portal desativado — faça upgrade para o plano Business para reativar.",
    "visibilityLabel": "Acesso ao portal",
    "visibilityPublic": "Público",
    "visibilityPrivate": "Privado",
    "visibilityPublicHelp": "Qualquer pessoa com o link pode navegar pelos seus guias.",
    "visibilityPrivateHelp": "Apenas membros da empresa podem acessar o portal.",
    "searchPlaceholder": "Buscar guias...",
    "sortNewest": "Mais recentes",
    "sortOldest": "Mais antigos",
    "sortTitleAsc": "Título A–Z",
    "sortTitleDesc": "Título Z–A",
    "noResults": "Nenhum guia encontrado",
    "shareLink": "Copiar link",
    "linkCopied": "Link copiado!",
    "home": "Inicio",
    "noGuidesInSection": "Nenhum guia nesta seção ainda",
    "portalPagesSection": "Páginas do Portal",
    "portalPagesSectionDescription": "Gerencie as páginas do portal e organize os guias em seções.",
    "addSubpage": "Adicionar subpágina",
    "subpageNameLabel": "Nome da página",
    "subpageNamePlaceholder": "ex: Treinamento",
    "subpageSlugLabel": "Slug da URL",
    "subpageVisibility": "Visibilidade",
    "subpagePublic": "Público",
    "subpagePrivate": "Apenas membros",
    "subpageGuideCount": "{count} guias",
    "subpageGuideCountSingular": "1 guia",
    "subpageGuideCountZero": "Nenhum guia",
    "deleteSubpage": "Excluir",
    "deleteSubpageTitle": "Excluir subpágina",
    "deleteSubpageConfirm": "Isso tornará {count} guias privados. Tem certeza?",
    "deleteSubpageConfirmEmpty": "Tem certeza que deseja excluir esta subpágina?",
    "editSubpage": "Editar",
    "saveSubpage": "Salvar",
    "cancelEdit": "Cancelar",
    "brandingSection": "Identidade Visual",
    "brandingSectionDescription": "Personalize a aparência do seu portal com logo, cores e imagens.",
    "logoLabel": "Logo",
    "logoHint": "PNG, JPEG, WebP ou GIF. Máximo 2MB.",
    "coverImageLabel": "Imagem de Capa",
    "coverImageHint": "Exibida como plano de fundo do cabeçalho. Máximo 2MB.",
    "faviconLabel": "Favicon",
    "faviconHint": "Apenas PNG. Máximo 2MB.",
    "brandColorLabel": "Cor da Marca",
    "brandColorHint": "Essa cor será usada nos links, botões e destaques do portal.",
    "brandColorPlaceholder": "#3b82f6",
    "brandColorReset": "Restaurar padrão",
    "contrastWarning": "Essa cor pode ter baixo contraste em fundos claros.",
    "uploadImage": "Enviar imagem",
    "removeImage": "Remover",
    "brandingSave": "Salvar identidade visual",
    "brandingSaved": "Identidade visual salva!"
  },
  "aiWriterPage": {
    "title": "AI Writers",
    "description": "Escolha seu AI Writer padrão. Isso controla como a IA aprimora o conteúdo dos seus guias — o público para quem escreve, o tom que usa e o nível de detalhe.",
    "audience": "Público",
    "tone": "Tom",
    "detail": "Nível de Detalhe",
    "default": "Padrão",
    "selected": "Selecionado",
    "setDefault": "Definir como Padrão",
    "customWriters": "Writers Personalizados",
    "createCustom": "Criar AI Writer",
    "editCustom": "Editar",
    "deleteCustom": "Excluir",
    "customName": "Nome",
    "customAudience": "Público",
    "customTone": "Tom",
    "customDetail": "Nível de Detalhe",
    "customNamePlaceholder": "ex: Writer de Compliance",
    "customAudiencePlaceholder": "Descreva quem vai ler os guias...",
    "customTonePlaceholder": "Descreva o tom e a voz...",
    "customDetailPlaceholder": "Descreva o nível de detalhe...",
    "saveCustom": "Salvar",
    "cancelCustom": "Cancelar",
    "deleteConfirm": "Tem certeza que deseja excluir este AI Writer?",
    "businessOnly": "AI Writers personalizados estão disponíveis no plano Business.",
    "writerSubtitle": {
      "standard": "Tom balanceado para documentação geral",
      "quick_reference": "Passos concisos e diretos para consulta rápida",
      "customer_support": "Amigável e detalhado para usuários externos",
      "training": "Instrutivo e metódico para aprendizado"
    },
    "writers": {
      "standard": {
        "audience": "Escreva para membros da equipe que já conhecem a ferramenta. Use terminologia específica sem explicações. Assuma familiaridade com a interface.",
        "tone": "Use um tom neutro e profissional. Seja claro e direto, sem ser rígido ou informal demais.",
        "detail": "Use detalhamento padrão. 1–2 frases por descrição de passo. Inclua explicações breves onde agregam clareza, sem elaborar ações óbvias."
      },
      "quick_reference": {
        "audience": "Escreva para membros da equipe que já conhecem o processo e precisam de uma consulta rápida. Assuma total familiaridade com a ferramenta.",
        "tone": "Use um tom neutro e objetivo. Seja direto e eficiente.",
        "detail": "Seja conciso. No máximo 1 frase por descrição de passo. Indique apenas a ação a ser realizada. Omita explicações, contexto e dicas."
      },
      "customer_support": {
        "audience": "Escreva para clientes ou usuários externos realizando uma tarefa no seu produto. Use linguagem simples e acolhedora. Evite jargão interno.",
        "tone": "Use uma voz amigável e acolhedora. Seja paciente e tranquilizador. Use segunda pessoa e linguagem positiva.",
        "detail": "Seja detalhado. 2–3 frases por descrição de passo. Explique o que o usuário verá em cada etapa e o que cada ação realiza."
      },
      "training": {
        "audience": "Escreva para pessoas aprendendo este processo como parte de um treinamento. Explique o propósito de cada passo. Conecte ações a resultados.",
        "tone": "Use um tom neutro e instrutivo. Seja claro e metódico, como um manual de treinamento.",
        "detail": "Seja detalhado. 2–3 frases por descrição de passo. Explique por que cada passo é importante e como se encaixa no processo geral."
      }
    }
  },
  "aiWriter": {
    "label": "AI Writer",
    "standard": "Padrão",
    "quick_reference": "Referência Rápida",
    "customer_support": "Suporte ao Cliente",
    "training": "Treinamento"
  },
  "narrationInfluence": {
    "label": "Influência da narração",
    "hint": "Quanto o áudio narrado influencia as descrições polidas.",
    "light": "Leve",
    "lightHint": "Usa a narração só para pequenos detalhes.",
    "balanced": "Equilibrada",
    "balancedHint": "Usa a narração para explicar o porquê de cada passo.",
    "heavy": "Forte",
    "heavyHint": "Quase transcreve o que foi falado, no passo certo."
  },
  "interactive": {
    "guideTypeLabel": "Tipo de guia",
    "guideTypeLinear": "Linear",
    "guideTypeInteractive": "Interativo",
    "branchLabel": "Caminho",
    "decisionPoint": "Ponto de decisão",
    "selectBranch": "Selecione um caminho",
    "backToDecision": "Voltar à decisão",
    "noStepsRecorded": "Nenhum passo registrado para este caminho",
    "missingScreenshot": "Captura de tela ausente",
    "pdfNotAvailable": "A exportação em PDF ainda não está disponível para guias interativos",
    "breadcrumbStart": "Início",
    "splitIntoBranches": "Dividir em caminhos",
    "dragToMove": "Arraste para mover entre caminhos",
    "clickToExpand": "Clique para expandir",
    "removeBranches": "Remover caminhos",
    "markedDecisionPoint": "Marcado como ponto de decisão",
    "markAsDecisionPoint": "Marcar como ponto de decisão",
    "unmarkDecisionPoint": "Desmarcar ponto de decisão"
  },
  "onboarding": {
    "step2": {
      "title": "Instale a extensão do navegador",
      "subtitle": "Grave sua tela e narre — a extensão captura tudo.",
      "description": "A extensão do Instruo Recorder captura capturas de tela, cliques e narração enquanto você trabalha — e transforma tudo em um guia polido automaticamente.",
      "installButton": "Instalar extensão"
    },
    "step3": {
      "title": "Escolha seu plano de avaliação",
      "subtitle": "Experimente todos os recursos por 30 dias. Você pode mudar a qualquer momento."
    },
    "plans": {
      "pro": {
        "name": "Pro",
        "description": "Para profissionais independentes — guias ilimitados, PDF e exportação em vídeo"
      },
      "business": {
        "name": "Business",
        "description": "Para equipes — tudo do Pro + portal, analytics e AI Writers personalizados"
      }
    },
    "loading": "Carregando...",
    "continue": "Continuar →",
    "startTrial": "Iniciar avaliação gratuita"
  },
  "feedback": {
    "button": "Dar feedback",
    "title": "O que está pensando?",
    "placeholder": "Conte o que você acha, reporte um bug ou sugira uma melhoria...",
    "attachScreenshot": "Anexar captura de tela",
    "submit": "Enviar",
    "thanks": "Obrigado pelo seu feedback!"
  },
  "survey": {
    "dismiss": "Dispensar",
    "first_guide_published": {
      "title": "Como foi a experiência de criar seu primeiro guia?",
      "placeholder": "Alguma sugestão? (opcional)"
    }
  },
  "analytics": {
    "title": "Analytics",
    "totalVisits": "Total de Visitas",
    "completeViews": "Visualizações Completas",
    "avgTimeSpent": "Tempo Médio",
    "videoViews": "Visualizações do Vídeo",
    "viewer": "Visitante",
    "scrollPercentage": "Scroll %",
    "timeSpent": "Tempo",
    "viewedAt": "Data / Hora",
    "source": "Origem",
    "anonymous": "Anônimo",
    "noViews": "Nenhuma visualização ainda. Compartilhe seu guia para começar a rastrear.",
    "privateGuideNotice": "Este guia é privado. Altere a visibilidade para público ou empresa para começar a rastrear visualizações.",
    "companyTitle": "Analytics da Empresa",
    "guideColumn": "Guia",
    "viewDetails": "Ver Detalhes",
    "author": "Autor",
    "totalVisitsHelp": "Total de acessos de todos os visitantes.",
    "completeViewsHelp": "Visitantes que leram o guia até o final (95%+ de scroll).",
    "videoViewsHelp": "Visitantes que assistiram ao vídeo do guia.",
    "searchGuides": "Buscar guias...",
    "noResults": "Nenhum guia encontrado.",
    "visibility": {
      "private_guide": "Privado",
      "company": "Empresa",
      "public_guide": "Público"
    },
    "page": "Página",
    "of": "de",
    "previous": "Anterior",
    "next": "Próxima",
    "seconds": "s",
    "minutes": "min",
    "upgradeTitle": "Analytics",
    "upgradeDescription": "Faça upgrade para o plano Business para ver quem visualizou seus guias, o quanto leram e mais.",
    "upgradeButton": "Fazer Upgrade"
  },
  "admin": {
    "users": {
      "title": "Admin · Usuários",
      "description": "Entre como qualquer usuário para depurar, dar suporte ou verificar a experiência dele.",
      "searchPlaceholder": "Buscar por e-mail ou nome…",
      "search": "Buscar",
      "clear": "Limpar",
      "impersonate": "Personificar",
      "empty": "Nenhum usuário corresponde à sua busca.",
      "tableEmail": "E-mail",
      "tableName": "Nome",
      "tablePlan": "Plano",
      "tableStatus": "Status",
      "tableGuides": "Guias",
      "tableConfirmed": "Confirmado",
      "tableInvited": "Convidado",
      "tableCreated": "Criado em",
      "tableActions": "Ações",
      "previous": "Anterior",
      "next": "Próxima",
      "pageOf": "Página {page} de {total}",
      "yes": "Sim",
      "no": "Não",
      "status": {
        "paying": "Pagante",
        "trialing": "Em trial",
        "locked": "Bloqueado"
      }
    }
  },
  "impersonationBanner": {
    "label": "Personificando {email}",
    "stop": "Encerrar personificação"
  },
  "video": {
    "title": "Vídeo",
    "generate": "Gerar Vídeo",
    "generating": "Gerando vídeo...",
    "processingDescription": "Seu vídeo está sendo gerado. Isso pode levar alguns minutos.",
    "ready": "Vídeo pronto",
    "failed": "Falha ao gerar o vídeo.",
    "retry": "Tentar Novamente",
    "statusNotCreated": "Crie seu vídeo",
    "statusCreating": "Gerando vídeo...",
    "statusCreated": "Vídeo pronto",
    "statusOutdated": "Vídeo desatualizado",
    "statusFailed": "Vídeo com falha",
    "videoSettingsAriaLabel": "Opções de vídeo",
    "videoSettingsTooltip": "Ajustar configurações do vídeo",
    "statusTooltipNotCreated": "Criar vídeo a partir dos passos deste guia",
    "statusTooltipProcessing": "A IA está gerando o vídeo",
    "statusTooltipReady": "O vídeo está atualizado com a versão mais recente do guia",
    "statusTooltipUpdate": "Atualizar o vídeo com novas configurações",
    "statusTooltipStale": "O guia mudou desde a última geração — clique para atualizar",
    "statusTooltipFailed": "Falha ao gerar — clique para tentar novamente",
    "download": "Baixar MP4",
    "noSteps": "Adicione passos com screenshots ao seu guia antes de gerar um vídeo.",
    "emptyTitle": "Transforme seu guia em vídeo",
    "emptyDescription": "A IA narra cada passo com voz natural, mostrando os screenshots e indicadores de clique do seu guia.",
    "viewGuide": "Ver o guia",
    "stepSingular": "passo",
    "stepPlural": "passos",
    "outdated": "Este vídeo está desatualizado. Gere novamente para refletir as alterações.",
    "regenerate": "Gerar novamente",
    "updateVideo": "Atualizar vídeo",
    "share": "Compartilhar",
    "copyLink": "Copiar link",
    "linkCopied": "Copiado!",
    "settings": {
      "title": "Configurações do vídeo",
      "description": "Ajuste como este vídeo será gerado.",
      "showAuthorLabel": "Mostrar autor do guia",
      "showAuthorHint": "Quando ativo, o card inicial inclui 'por {autor}'.",
      "announceStepNumbersLabel": "Anunciar números dos passos na narração",
      "announceStepNumbersHint": "Quando ativo, a narração começa cada passo com '1.', '2.', etc.",
      "orientationLabel": "Orientação",
      "horizontal": "Horizontal",
      "horizontalHint": "16:9, ideal para telas e apresentações.",
      "vertical": "Vertical",
      "verticalHint": "9:16, ideal para Instagram e redes sociais.",
      "narrationSpeedLabel": "Velocidade da narração",
      "narrationSpeedHint": "1× é o ritmo padrão. Valores maiores deixam a narração mais rápida.",
      "voiceLabel": "Narrador",
      "voiceHint": "Escolha a voz da narração. Toque em ▶ para ouvir uma amostra.",
      "preview": "Ouvir amostra",
      "voices": {
        "warm": "Feminina, calorosa",
        "soft": "Feminina, suave",
        "expressive": "Feminina, expressiva",
        "deep": "Masculina, grave",
        "neutral": "Masculina, neutra",
        "calm": "Masculina, calma"
      },
      "cancel": "Cancelar",
      "generate": "Gerar vídeo",
      "regenerate": "Gerar novamente"
    }
  }
}
